import React from 'react'
import { Typography, Box, CircularProgress } from '@mui/material'
import { TextField } from 'mui-rff'

export const BasicTextField = ({
  label,
  fieldName,
  type = '',
  required = false,
  disabled = false,
  isLoading = '',
}) => {
  return (
    <>
      <Typography variant='h5'>{label}</Typography>
      <Box display='flex' flexDirection='row' alignItems='center'>
        <TextField
          name={fieldName}
          margin='none'
          size='small'
          type={type}
          required={required}
          disabled={disabled}
        />
        {isLoading && <CircularProgress size='1.5rem' />}
      </Box>
    </>
  )
}
